// export default {
//   table: {
//     tableClass: "table table-striped table-bordered",
//     ascendingIcon: "glyphicon glyphicon-chevron-up",
//     descendingIcon: "glyphicon glyphicon-chevron-down",
//     handleIcon: "glyphicon glyphicon-menu-hamburger",
//     renderIcon: function(classes) {
//       return `<span class="${classes.join(' ')}"></span>`
//     }
//   },
//   paginationInfo: {
//     infoClass: 'pull-left'
//   },
//   pagination: {
//     wrapperClass: "pagination pull-right float-right",
//     activeClass: "btn-primary",
//     disabledClass: "disabled",
//     pageClass: "btn btn-border",
//     linkClass: "btn btn-border",
//     icons: {
//       first: "",
//       prev: "",
//       next: "",
//       last: ""
//     }
//   }
// };  

// // Bootstrap4 + FontAwesome Icon
// export default {
//   table: {
//     tableWrapper: '',
//     tableHeaderClass: 'mb-0',
//     tableBodyClass: 'mb-0',
//     tableClass: 'table table-bordered table-hover table-striped',
//     loadingClass: 'loading',
//     ascendingIcon: 'fas fa-chevron-up',
//     descendingIcon: 'fas fa-chevron-down',
//     ascendingClass: 'sorted-asc',
//     descendingClass: 'sorted-desc',
//     sortableIcon: 'fas fa-sort',
//     detailRowClass: 'vuetable-detail-row',
//     handleIcon: 'fas fa-bars text-secondary',
//     renderIcon(classes, options) {
//       return `<i class="${classes.join(" ")}" ${options}></span>`;
//     }
//   },
//   pagination: {
//     wrapperClass: 'pagination float-right',
//     activeClass: 'active',
//     disabledClass: 'disabled',
//     pageClass: 'page-item page-link',
//     linkClass: 'page-link',
//     paginationClass: 'pagination',
//     paginationInfoClass: 'float-left',
//     dropdownClass: 'form-control',
//     icons: {
//       first: 'fas fa-chevron-left',
//       prev: 'fas fa-chevron-left',
//       next: 'fas fa-chevron-right',
//       last: 'fas fa-chevron-right',
//     }
//   }
// }

// Bootstrap4 + FontAwesome Icon
export default {
  table: {
    tableWrapper: '',
    tableHeaderClass: 'mb-0',
    tableBodyClass: 'mb-0',
    tableClass: 'table table-bordered table-striped',
    loadingClass: 'loading',
    ascendingIcon: 'fa fa-chevron-up',
    descendingIcon: 'fa fa-chevron-down',
    ascendingClass: 'sorted-asc',
    descendingClass: 'sorted-desc',
    sortableIcon: 'fa fa-sort',
    detailRowClass: 'vuetable-detail-row',
    handleIcon: 'fa fa-bars text-secondary',
    renderIcon(classes) {
      return `<i class="${classes.join(' ')}"></span>`
    }
  },
  pagination: {
    wrapperClass: 'pagination float-right',
    activeClass: 'active',
    disabledClass: 'disabled',
    pageClass: 'page-item',
    linkClass: 'page-link',
    paginationClass: 'pagination',
    paginationInfoClass: 'float-left',
    dropdownClass: 'form-control',
    icons: {
      first: 'fa fa-chevron-left',
      prev: 'fa fa-chevron-left',
      next: 'fa fa-chevron-right',
      last: 'fa fa-chevron-right',
    }
  }
}
